// extracted by mini-css-extract-plugin
export default {"change-button":"_1NbVXiEatt3IPqCkQ3231M","change-button__icon":"_3BI18iWxshRNYTejVjnv1z"};